import { render, staticRenderFns } from "./notice-detail.vue?vue&type=template&id=8278af04&scoped=true&"
import script from "./notice-detail.vue?vue&type=script&lang=js&"
export * from "./notice-detail.vue?vue&type=script&lang=js&"
import style0 from "./notice-detail.vue?vue&type=style&index=0&id=8278af04&prod&lang=scss&scoped=true&"
import style1 from "./notice-detail.vue?vue&type=style&index=1&id=8278af04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8278af04",
  null
  
)

export default component.exports